/**
 * @version 1.1
 * @author Kelnik Studios {http://kelnik.ru}
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/alert-old-browser.html documentation
 */

/**
 * DEPENDENCIES
 */
import merge from 'lodash/merge';

class AlertOldBrowser {
    init(options) {
        this.setSettings(options);
        this.checkBrowserName();
    }

    /* eslint-disable max-lines-per-function */
    getBrowser() {
        const ua = navigator.userAgent;
        let bName = (function() { // eslint-disable-line
            if (ua.search(/Edge/) > -1) {
                return 'edge';
            }
            if (ua.search(/MSIE/) > -1) {
                return 'ie';
            }
            if (ua.search(/Trident/) > -1) {
                return 'ie11';
            }
            if (ua.search(/Firefox/) > -1) {
                return 'firefox';
            }
            if (ua.search(/Opera/) > -1) {
                return 'opera';
            }
            if (ua.search(/OPR/) > -1) {
                return 'operaWebkit';
            }
            if (ua.search(/YaBrowser/) > -1) {
                return 'yabrowser';
            }
            if (ua.search(/Chrome/) > -1) {
                return 'chrome';
            }
            if (ua.search(/Safari/) > -1) {
                return 'safari';
            }
            if (ua.search(/Maxthon/) > -1) {
                return 'maxthon';
            }
        }());

        let version = '';

        switch (bName) {
            case 'edge':
                version = ua.split('Edge')[1].split('/')[1];
                break;
            case 'ie':
                version = ua.split('MSIE ')[1].split(';')[0];
                break;
            case 'ie11':
                bName = 'ie';
                version = ua.split('; rv:')[1].split(')')[0];
                break;
            case 'firefox':
                version = ua.split('Firefox/')[1];
                break;
            case 'opera':
                version = ua.split('Version/')[1];
                break;
            case 'operaWebkit':
                bName = 'opera';
                version = ua.split('OPR/')[1];
                break;
            case 'yabrowser':
                version = ua.split('YaBrowser/')[1].split(' ')[0];
                break;
            case 'chrome':
                version = ua.split('Chrome/')[1].split(' ')[0];
                break;
            case 'safari':
                let separator = 'Version/'; // eslint-disable-line

                if (ua.search(/CriOS/) > -1) {
                    separator = 'CriOS/';
                    bName = 'chrome';
                }

                if (ua.search(/FxiOS/) > -1) {
                    separator = 'FxiOS/';
                    bName = 'firefox';
                }

                version = ua.split(separator)[1].split(' ')[0];
                break;
            case 'maxthon':
                version = ua.split('Maxthon/')[1];
                break;
            default:
                version = false;
                break;
        }
        let platform = 'desktop';

        if ((/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase())) {
            platform = 'mobile';
        }
        let browsrObj = null;

        try {
            browsrObj = {
                platform,
                browser     : bName,
                versionFull : version,
                versionShort: version.split('.')[0]
            };
        } catch (err) {
            browsrObj = {
                platform,
                browser     : 'unknown',
                versionFull : 'unknown',
                versionShort: 'unknown'
            };
        }

        return browsrObj;
    }
    /* eslint-enable max-lines-per-function */

    setSettings(options) {
        const defaultBrowserSupport = [{
            name   : 'chrome',
            version: 57
        }, {
            name   : 'firefox',
            version: 53
        }, {
            name   : 'opera',
            version: 44
        }, {
            name   : 'ie',
            version: 12
        }, {
            name   : 'safari',
            version: 11
        }, {
            name   : 'android',
            version: 5
        }, {
            name   : 'ios',
            version: 10
        }];

        this.supportBrowsers = merge(defaultBrowserSupport, options);
        this.userBrowser = this.getBrowser();
        this.body = document.body;
        this.popup = null;
    }

    /**
     * Определение имени браузера
     */
    checkBrowserName() {
        this.supportBrowsers.forEach((item) => {
            if (this.userBrowser.browser === item.name) {
                this.checkBrowserVersion(item);
            }
        });
    }

    /**
     * Определение версии браузера
     * @param {Object} supportBrowser -Сопоставленая версия браузера из настроек.
     */
    checkBrowserVersion(supportBrowser) {
        if (this.userBrowser.versionShort < supportBrowser.version) {
            $(`html, body`).addClass(`is-old-browser ${this.userBrowser.browser}-${this.userBrowser.versionShort}`);
            this.showPopup();
        }
    }

    /**
     * Получение элементов окна
     */
    getElements() {
        this.popup = $(`.alert-old-browser`);
        this.popup.removeClass(`is-hidden`);
    }

    /**
     * Открытие попапа
     */
    showPopup() {
        this.getElements();
    }

    addScript(src) {
        const script = document.createElement('script');

        script.src = src;
        script.async = false;
        document.body.appendChild(script);
    }
}

export default AlertOldBrowser;
